import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCtaCte = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'consulta_ctacte',
        name: 'Consulta CtaCte',
        component: ViewCtaCte,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
